import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';
const Navigation = ({ isMainNav = false, cta }) => {
    const state = useSelector(state => state.navigation);
    const { contentLinks, topLevelOpen } = state;
    return _jsx(NavigationItem, { links: contentLinks, isMainNav: isMainNav, topLevelOpen: topLevelOpen, cta: cta });
};
export default Navigation;
